<script setup lang="ts">
import { storeToRefs } from 'pinia';
import { useNotificationStore } from '@/stores/notification';
import { useI18n } from 'vue-i18n';

const store = useNotificationStore();
const { t } = useI18n();

const { show, message, color, timeout } = storeToRefs(store);
</script>

<template>
  <v-snackbar v-model="show" :color="color" :timeout="timeout" location="top" :elevation="6" rounded="lg">
    {{ message }}

    <template #actions>
      <v-btn color="white" variant="text" @click="store.hideNotification"> {{ t('general.close') }} </v-btn>
    </template>
  </v-snackbar>
</template>
